import styled from "styled-components";
import { Button as AntButton } from "antd";
import { IMG_WHEEL_BG, SpinHomeBg, RefreshOutlined } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	height: 100vh;
	overflow: hidden;

	background-image: url(${SpinHomeBg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: top;
`;
export const RefreshIcon = styled(RefreshOutlined)`
	font-size: 24px;
	color: #fff;
`;

export const DailyWinnerListContainer = styled.div`
	margin: 291px 0 0 0;
	flex-direction: column;
	align-items: center;

	@media screen and (min-width: 400px) {
		margin: 298px 0 0 0;
	}
`;

export const EmptyTextWrapper = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	svg{
		width: 40px;
		height: 40px;
	}
`;

export const Title = styled.div`
	text-align: center;
	
	color: #5C5C5C;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 28px; /* 155.556% */
	@media (min-height: 735px) and (max-height: 745px) {
		margin-bottom: 0px;
	}
`;

export const Number = styled.p`
	width: 30px;
	height: 30px;
	border-radius: 10px;
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);display: flex;
	justify-content: center;
	align-items: center;

	color: #F4F4F4;
	text-align: center;
	font-size: 10px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px; /* 200% */
	@media screen and (max-height: 670px) {
		font-size: 10px;
		line-height: 10px;
	}
`;

export const SpinnerBox = styled.div`
	width: 100%;
	position: sticky;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`;

export const OuterBadge = styled.img.attrs({
	alt: "badge",
	id: "badge-img",
	src: IMG_WHEEL_BG,
})`
	position: absolute;
	width: 250px;
	height: 250px;
	cursor: pointer;
	z-index: 200;
	top: 32px;
	margin-left: 0px;

	@media screen and (max-width: 350px) {
		width: 210px;
		height: 210px;
		margin-left: 0px;
		top: 51px;
	}
	@media screen and (max-height: 650px) {
		width: 220px;
		height: 220px;
		top: 10px;
	}
	@media screen and (max-height: 582px) {
		width: 185px;
		height: 185px;
		top: 12px;
	}
`;

export const WheelContainer = styled.div`
	/* position: fixed; */
	width: 100%;
	max-width: 480px;
	height: 293px;
	z-index: 800;
	display: flex;
	align-items: center;
	justify-content: center;

	> div {
		width: 230px;
		height: 230px;
		transform: rotate(-53deg);
	}

	img:not(#badge-img):not(#center) {
		display: none;
	}

	@media screen and (max-width: 350px) {
		> div {
			width: 190px;
			height: 190px;
		}
	}

	@media screen and (max-height: 650px) {
		> div {
			width: 205px;
			height: 205px;
		}
		height: 220px;
	}

	@media screen and (max-height: 582px) {
		> div {
			width: 170px;
			height: 170px;
		}
		height: 195px;
	}
`;

export const Container = styled.div`
	position: relative;
	z-index: 999;
	text-align: center;
	margin-top: 350px;

	.ant-btn {
		height: 52px;
		margin-top: 24px;
		max-width: 170px;
	}
`;

export const Text = styled.div`
	padding-bottom: 10px;
	color: #49028E;
	font-size: 18px;
`;

export const SpinWrapper = styled.div`
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	position: relative;
`;

export const WinnersContainer = styled.div`
	height: 100%;
	position: relative;
	overflow-y: auto;
`;

export const WinnerItem = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	align-items: flex-start;
	gap: 8px;

	padding: 5px 0;
	margin-bottom: 1px;

`;

export const LeftSection = styled.div`
	display: flex;
	align-items: flex-start;
	flex: 1;
`;

export const PhNameWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 3;
`;

export const NameWrapper = styled.div`
	color: #2A2A2A;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
	text-align: left;

	word-break: break-all;

	@media screen and (max-height: 670px) {
		font-size: 12px;
	}
`;

export const PhoneWrapper = styled.div`
	color: #2A2A2A;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
	@media screen and (max-height: 670px) {
		font-size: 12px;
	}
`;

export const AmountWrapper = styled.div`
	color: #AA5E1B;
	font-size: 16px;
	font-weight: 600;
	line-height: 15px;
	margin-top: 4px;
	@media screen and (max-height: 670px) {
		font-size: 14px;
	}
`;

export const BottomContainer = styled.div`
	display: flex;
	/* position: relative; */
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 1000;
	margin-top: -20px;
	@media screen and (max-height: 650px) {
		margin-top: 0;
	}
	@media screen and (max-height: 582px) {
		margin-top: 0;
	}
`;

export const TableContainer = styled.div`
	margin-top: 8px;
	height: calc(100vh - 70px - 235px - 55px - 110px);
	width: calc(100% - 32px);
	z-index: 99;
	/* position: relative; */
	box-sizing: border-box;
	border-radius: 16px;
	background: #FFF;
	padding: 16px;
	overflow: hidden;

/* drop shadow-exapnd */
box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);

	/* overflow-y: hidden; */
	/* @media screen and (max-height: 830px) {
		height: 315px;
	}
	@media screen and (max-height: 800px) {
		height: 285px;
	}
	@media screen and (max-height: 770px) {
		height: 260px;
	}
	@media screen and (max-height: 744px) {
		height: 230px;
	}
	@media screen and (max-height: 712px) {
		height: 200px;
	}
	@media screen and (max-height: 683px) {
		height: 170px;
	} */

	@media screen and (max-height: 650px) {
		height: calc(100vh - 70px - 180px - 55px - 110px);
	} 

	@media screen and (max-height: 582px) {
		height: calc(100vh - 70px - 180px - 55px - 75px);
	}
`;

export const WinnerTitle = styled.div`
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`

export const ButtonWrapper = styled.div`
	/* max-width: 448px; */
	max-width: calc(100% - 32px);
	height: 49.25px;
	display: flex;
	gap: 12px;
	justify-content: space-between;
	padding: 5px 0;
	margin: 0 16px;
	position: absolute;
	bottom: 0;
	width: 100%;
	@media screen and (max-height: 650px) {
		height: 45px;
	}
	/* @media (max-width: 370px) {
		width: 330px;
	}
	@media (max-width: 330px) {
		width: 300px;
	} */
	@media screen and (max-height: 582px) {
		bottom: 0px;
		height: 38px;
	}

	/* @media screen and (max-width: 460px) {
		max-width: 400px;
	}

	@media screen and (max-width: 400px) {
		max-width: 370px;
	}

	@media screen and (max-width: 370px) {
		max-width: 340px;
	} */
`;

export const ButtonDiv = styled.div`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	border-radius: 8px;
	border: 1px solid #FFF;
	background: rgba(0, 0, 0, 0.30);
	backdrop-filter: blur(25px);


	color: #FFF;
	text-align: center;
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 26px; /* 162.5% */
	/* @media screen and (max-height: 582px) {
		width: 42%;
	} */
`;

export const LoadMoreWrapper = styled.div`
	text-decoration: underline;
	color: #d28a28;
	font-size: 14px;
	font-weight: 100;
	line-height: 17.5px;
	cursor: pointer;
	margin: 10px 0;
`;

export const StartButton = styled(AntButton)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: calc(100% - 32px);
	height: 55px;
	border-radius: 8px;
	border: 2px solid #FFF !important;
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
	box-shadow: 0px 8px 116px 0px rgba(0, 0, 0, 0.10);
`;

export const CenterIcon = styled.img.attrs((props) => ({
	id: props.id,
	src: props.src,
}))`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1000;
	width: 50px;
	height: 50px;

	@media screen and (max-width: 325px) {
		width: 40px;
		height: 40px;
	}
`;
